export default {
  accountClosedLabelText: 'Account Closed',
};
